import { Grid } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../atomic/atoms';
import { OrderCommand } from '../../services/command';
import Swal from 'sweetalert2';
import { SCUIBreadCrumb, SCUITextFieldWithButton } from '../../atomic/molecules';
import { SCUISearchServiceAddToListModal } from '../SearchService/components';
import { ONF } from './orderNotFinance.classes';

export const OrderNotFinance: FC<any> = () => {
    const { t } = useTranslation();
    let searchKeyArr: any = [];
    const [ordersId, setOrdersId] = useState('');
    const [listModalOpen, setListModalOpen] = useState(false);

    const handleCloseModal = () => {
        setListModalOpen(false);
    };

    const PostOrderNotFinance = async () => {
        console.info(searchKeyArr);
        let params: any = {
            orderIds: searchKeyArr,
        };
        let myArray = [];
        myArray.push(ordersId);
        if (searchKeyArr && searchKeyArr[0] != 0) {
            OrderCommand.PostOrdersNotFinance(params)
                .then((res: any) => {
                    if (res === 1) {
                        Swal.fire(t('general.operationCompleted'), ' ', 'success');
                        setListModalOpen(false);
                        searchKeyArr = [];
                    } else {
                        Swal.fire('Servis Hatası ', ' ', 'error');
                    }
                })
                .catch((error: any) => {
                    Swal.fire(t('general.error'), ' ', 'error');
                    console.log('Hata :>> ', error);
                })
                .finally(() => {});
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };

    const AllOnClick = () => {
        listele();
    };

    const listele = async () => {
        ordersId
            .trim()
            .split('\n')
            .forEach((item: any) => {
                searchKeyArr.push(Number(item));
            });
        PostOrderNotFinance();
    };

    return (
        <SCUIContent className={ONF.root}>
            <SCUIBreadCrumb title={'Finansa Gitmeyen Sparişler'} componentLink={'OrderNotFinance'} />
            <Grid className={ONF.searchGrid} container>
                <SCUISearchServiceAddToListModal
                    open={listModalOpen}
                    onClose={handleCloseModal}
                    orderNo={ordersId}
                    setOrderNo={setOrdersId}
                    listele={listele}
                    text={'Orders Id'}
                />
                <SCUITextFieldWithButton
                    buttonText={t('general.send')}
                    placeholder={'OrdersId'}
                    onChange={(event: any) => {
                        setOrdersId(event.target.value);
                    }}
                    onClick={() => AllOnClick()}
                    onKeyPress={(e: any) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            AllOnClick();
                        }
                    }}
                    paperClassName={ONF.inputWithButtonPaper}
                    inputClassName={ONF.inputOrdersId}
                    buttonClassName={ONF.inputSendButton}
                />
                <SCUIButton
                    className={ONF.batchSearchButton}
                    text={t('general.batchSearch')}
                    type="secondary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={() => setListModalOpen(true)}
                />
            </Grid>
        </SCUIContent>
    );
};
